import {IAppModel, IRootScope} from "../hpc";
import {PushNotificationService} from "../services/PushNotificationService";

export let LogoutCtrl = [
	'$scope',
	'$rootScope',
	'$sessionStorage',
	'$localStorage',
	'$location',
	'$cookies',
	'$log',
	'pushNotificationService',
	function ($s: any,
			  $rs: IRootScope,
			  appModel: IAppModel,
			  $localStorage: any,
			  $location: ng.ILocationService,
			  $cookies: ng.cookies.ICookiesService,
			  $log: ng.ILogService,
			  pushNotificationService: PushNotificationService) {

		function logout() {
			// Handle push notification cleanup
			if (pushNotificationService.isInNativeApp()) {
				pushNotificationService.notifyNativeAppLogout();
			} else if (pushNotificationService.isSupported()) {
				pushNotificationService.unsubscribe().then(function() {
					$log.info('Push notification unsubscribed');
				}, function(error) {
					$log.warn('Push notification unsubscribe failed:', error);
				});
			}
			console.log('logging out');
			$cookies.remove("userLogin", {
				path: "/",
				secure: true,
				samesite: "strict"
			});
			$cookies.remove("remember", {
				path: "/",
				secure: true,
				samesite: "strict"
			});
			// backward compatibility
			$cookies.remove("userLogin", {
				path: "/v2/",
				secure: false,
				samesite: null
			});
			$cookies.remove("remember", {
				path: "/v2/",
				secure: false,
				samesite: null
			});
			delete appModel.userToken;
			delete appModel.account;
			delete $localStorage.rememberMeToken;
			delete $localStorage.userLogin;
			sessionStorage.removeItem("ngStorage-userToken");
			sessionStorage.removeItem("ngStorage-account");
			delete appModel.account;
			$location.path('/login');
		}

		logout();
	}
];
